export const PLACES = [
  {
    slug: 'bosworth',
    name: 'Battle of Bosworth',
    siteType: 'battlefield',
    primaryEra: 'late-medieval',
    country: 'england',
    region: 'midlands',
    teaser:
      'Richard III and Henry Tudor clashed here in 1485, closing the Wars of the Roses and crowning a new dynasty.',
    latitude: 52.598,
    longitude: -1.409,
    timeline_start: 1485,
    timeline_end: 1485,
    location_label: 'Near Market Bosworth, Leicestershire, England',
    era_primary: 'Late Medieval',
    era_range: '1485',
    types: ['Battlefield', 'Historic Site'],
    summaries: {
      gen: 'The Battle of Bosworth, fought in 1485, effectively ended the Wars of the Roses. Richard III was killed on the field and Henry Tudor became Henry VII, founding the Tudor dynasty. Bosworth marks the moment when a medieval civil war gave way to a new royal house and a different style of monarchy. Today the battlefield visitor centre explores the shifting loyalties, tactics, and myths that surround this decisive clash.',
    },
    echo: {
      title: 'A Crown Lost in a Marsh',
      text: 'According to later tradition, Richard III’s crown was lost in the chaos of the battle and recovered after the fighting, possibly in a patch of marshy ground. It was then placed on Henry Tudor’s head on the field itself. Whether the story is literally true or not, it captures the speed with which fortune turned that day: in a few violent hours, one king was dead and another crowned.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Bosworth%20Battlefield%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Battle_of_Bosworth_Field',
      official_site: 'https://www.bosworthbattlefield.org.uk/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'stonehenge',
    name: 'Stonehenge',
    siteType: 'stone circle',
    primaryEra: 'neolithic',
    country: 'england',
    region: 'wessex',
    teaser:
      'Rings of sarsen and bluestone on Salisbury Plain that have watched the sun rise for thousands of years.',
    latitude: 51.1789,
    longitude: -1.8262,
    timeline_start: -3000,
    timeline_end: -2000,
    location_label: 'Salisbury Plain, Wiltshire, England',
    era_primary: 'Neolithic',
    era_range: '~3000–2000 BCE',
    types: ['Megalithic Monument', 'Ancient Monument', 'World Heritage Site'],
    summaries: {
      gen: 'One of the world’s most famous prehistoric monuments, Stonehenge began as a simple earthwork enclosure before great sarsen and bluestone circles were raised in the Neolithic. Aligned with the movements of the sun, it has drawn engineers, antiquaries and day-trippers for centuries, and still anchors debates about ritual, landscape and power in prehistoric Britain.',
    },
    echo: {
      title: 'The Amesbury Archer',
      text: 'He came from far across the sea, his teeth still whispering of Alpine lands. Buried just a few miles from Stonehenge, the Amesbury Archer was laid to rest with gold ornaments, copper knives, and a quiver full of arrows. Over 4,000 years ago, he may have watched the great sarsens rise, his foreign accent strange to local ears. Did he bring new skills in metalwork, or was he drawn here by the stones’ growing legend? As the sun climbs between the ancient uprights today, imagine him standing among the builders—an outsider who became part of the henge’s story.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Stonehenge%2C%20UK&output=embed&w=425&h=350',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Stonehenge',
      official_site: 'https://www.english-heritage.org.uk/visit/places/stonehenge/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'loch-ness',
    name: 'Loch Ness',
    siteType: 'loch',
    primaryEra: 'early-medieval',
    country: 'scotland',
    region: 'highlands',
    teaser:
      'A glacial trench lake that guards Pictish legends, monastic ruins, and tales of creatures beneath the surface.',
    latitude: 57.3229,
    longitude: -4.4244,
    timeline_start: 500,
    timeline_end: 2025,
    location_label: 'Scottish Highlands, near Inverness',
    era_primary: 'Medieval to Modern',
    era_range: 'Early medieval legends to present day',
    types: ['Loch', 'Legendary Location', 'Natural Landscape'],
    summaries: {
      gen: 'Loch Ness is a vast, deep freshwater loch running along the Great Glen in the Scottish Highlands. It is famous worldwide for the legend of the Loch Ness Monster, affectionately called “Nessie”, but the area also has a rich history of Pictish kingdoms, medieval castles, and canal engineering. Long before sonar scans and tourist cruises, the loch was a working waterway in a dramatic glacial landscape.',
    },
    echo: {
      title: 'A Monster in the Columns of Newsprint',
      text: 'Stories of strange creatures in Loch Ness go back centuries, but the modern “Nessie” phenomenon really took off in the 1930s, when a series of newspaper reports and grainy photographs captivated the public. Each new sighting, hoax, or scientific survey says as much about what people want to believe as it does about what lies beneath the dark water. The monster is part folklore, part media creation, and now part of the local economy.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Loch%20Ness%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Loch_Ness',
      official_site: 'https://www.visitinvernesslochness.com/loch-ness',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'edinburgh-castle',
    name: 'Edinburgh Castle',
    siteType: 'castle',
    primaryEra: 'high-medieval',
    country: 'scotland',
    region: 'lothian',
    teaser:
      'Perched on Castle Rock, it watched over royals, sieges, and the nation’s regalia for nearly a millennium.',
    latitude: 55.9486,
    longitude: -3.1999,
    timeline_start: 1100,
    timeline_end: 1900,
    location_label: 'Castle Rock, overlooking Edinburgh, Scotland',
    era_primary: 'Medieval to Modern',
    era_range: '12th century onwards',
    types: ['Castle', 'Fortress', 'Royal Residence', 'National Symbol'],
    summaries: {
      gen: 'Edinburgh Castle dominates the skyline of Scotland’s capital from its volcanic rock. It has served as royal residence, fortress, armoury, and prison, witnessing everything from medieval sieges to Jacobite risings. The Honours of Scotland and the Stone of Destiny are kept here, and the daily firing of the One O’Clock Gun echoes its long military role.',
    },
    echo: {
      title: 'The Stone and the Crown',
      text: 'For centuries the Stone of Destiny was used in the inauguration of Scottish kings before being taken to Westminster Abbey in 1296 as a symbol of conquest. It returned to Scotland in the late twentieth century and now rests in Edinburgh Castle alongside the Honours of Scotland. Together they turn a fortress of stone into a stage for debates about sovereignty and identity.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Edinburgh%20Castle%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Edinburgh_Castle',
      official_site: 'https://www.edinburghcastle.scot/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'warwick-castle',
    name: 'Warwick Castle',
    siteType: 'castle',
    primaryEra: 'late-medieval',
    country: 'england',
    region: 'midlands',
    teaser:
      'A mighty keep of the Kingmaker earls, overseeing the Avon and centuries of Tudor and Stuart spectacle.',
    latitude: 52.2797,
    longitude: -1.5856,
    timeline_start: 1068,
    timeline_end: 1900,
    location_label: 'Warwick, Warwickshire, England',
    era_primary: 'Medieval',
    era_range: '11th–15th centuries, later country house',
    types: ['Castle', 'Fortified Residence', 'Tourist Attraction'],
    summaries: {
      gen: 'Warwick Castle began as a Norman motte-and-bailey ordered by William the Conqueror and developed into a powerful stone fortress on the River Avon. For centuries it was home to influential earls and the setting for sieges, tournaments, and political drama. Later it became a grand country house and, more recently, a major visitor attraction blending preserved history with live shows and reconstructed interiors.',
    },
    echo: {
      title: 'The Kingmaker’s Stronghold',
      text: 'During the Wars of the Roses, Richard Neville, Earl of Warwick, used the castle as the base for his extraordinary influence over English politics. Nicknamed the “Kingmaker”, he helped make and unmake monarchs before dying in battle in 1471. Walking the walls today, it is easy to imagine his banners flying above a courtyard full of armed retainers and nervous messengers.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Warwick%20Castle%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Warwick_Castle',
      official_site: 'https://www.warwick-castle.com/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'york',
    name: 'York',
    siteType: 'city',
    primaryEra: 'viking-age',
    country: 'england',
    region: 'yorkshire',
    teaser:
      'From Eboracum to Jorvik to York Minster, the city bridges Roman legions, Norse traders, and ecclesiastical power.',
    latitude: 53.959,
    longitude: -1.0815,
    timeline_start: 71,
    timeline_end: 2025,
    location_label: 'North Yorkshire, England',
    era_primary: 'Multi-period',
    era_range: 'Roman Eboracum to modern city',
    types: ['Historic City', 'Roman Settlement', 'Viking Town', 'Medieval Centre'],
    summaries: {
      gen: 'York is one of Britain’s most historically layered cities. Founded as the Roman fortress of Eboracum, it later became the Viking stronghold of Jórvík and a major medieval ecclesiastical centre. Its walls, Minster, narrow streets, and riverside quays still reflect these overlapping eras. Today museums, ghost walks, and archaeological sites help visitors peel back the city’s Roman, Anglo-Saxon, Viking, and medieval pasts.',
    },
    echo: {
      title: 'A City of Many Names',
      text: 'York has been called Eboracum, Eoforwic, Jórvík, and finally York, each name reflecting a different ruling power and language. On the same patch of ground you can stand where Roman emperors died, Viking merchants traded, and medieval archbishops planned church politics. Few places in Britain show so clearly how cities are palimpsests, written and rewritten over centuries.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=York%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/York',
      official_site: 'https://www.visityork.org/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'lindisfarne',
    name: 'Lindisfarne',
    siteType: 'island',
    primaryEra: 'early-medieval',
    country: 'england',
    region: 'northumbria',
    teaser:
      'The Holy Island whose priory illuminated manuscripts and endured the first recorded Viking raid in Britain.',
    latitude: 55.6693,
    longitude: -1.7936,
    timeline_start: 635,
    timeline_end: 900,
    location_label: 'Holy Island, off the coast of Northumberland, England',
    era_primary: 'Early Medieval',
    era_range: '635–9th century, with later monastic revival',
    types: ['Monastery', 'Island', 'Christian Site'],
    summaries: {
      gen: 'Lindisfarne, also known as Holy Island, was founded in 635 as a Christian monastery by Saint Aidan. It became a centre of learning, culture, and faith in Anglo-Saxon England, famous for the illuminated Lindisfarne Gospels. In 793 it was the target of one of the first recorded Viking raids on Britain, an event that echoed across Europe and helped define the age of the Vikings.',
    },
    echo: {
      title: 'A Shock from the Sea',
      text: 'The Anglo-Saxon Chronicle describes the Viking raid on Lindisfarne in 793 with horror: church buildings looted, monks killed or enslaved, holy relics scattered. To later writers it looked like a sign of divine anger, but it also marked a shift in northern Europe as raiders, traders, and settlers from Scandinavia forced their way onto the political map. On the quiet tidal causeway today, it can be hard to imagine the terror of oars on the horizon.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Lindisfarne%2C%20Holy%20Island%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Lindisfarne',
      official_site: 'https://www.english-heritage.org.uk/visit/places/lindisfarne-priory/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'vindolanda',
    name: 'Vindolanda',
    siteType: 'roman fort',
    primaryEra: 'roman',
    country: 'england',
    region: 'northumberland',
    teaser:
      'An auxiliary fort south of Hadrian’s Wall where organic finds and the Vindolanda tablets reveal everyday frontier life.',
    latitude: 54.9902,
    longitude: -2.3671,
    timeline_start: 85,
    timeline_end: 410,
    location_label: 'Near Bardon Mill, Northumberland, England',
    era_primary: 'Roman',
    era_range: 'c. AD 85–410',
    types: ['Roman Fort', 'Roman Settlement', 'Archaeological Site'],
    summaries: {
      gen: 'Vindolanda is a Roman auxiliary fort just south of Hadrian’s Wall in northern England. For nearly three centuries it guarded the Stanegate road and housed soldiers and their families from across the empire. Archaeologists have uncovered extraordinary organic remains here, including shoes, combs, and the famous ink-written Vindolanda tablets, which reveal everyday letters and shopping lists from life on the frontier.',
    },
    echo: {
      title: 'A Birthday Party on the Edge of Empire',
      text: 'One tablet from Vindolanda preserves an invitation from a Roman officer’s wife, Claudia Severa, inviting her friend to a birthday party. Written in Latin but full of warmth, it is one of the earliest known letters in a woman’s own hand anywhere in Europe. Standing on the windswept hill above the fort, it is easy to imagine the candles, the chatter, and the clink of cups that once brightened this remote outpost.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Vindolanda%2C%20NE47%207JN%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Vindolanda',
      official_site: 'https://www.vindolanda.com/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'tower-of-london',
    name: 'The Tower of London',
    siteType: 'fortress',
    primaryEra: 'medieval',
    country: 'england',
    region: 'london',
    teaser:
      'William the Conqueror’s riverside stronghold that evolved into palace, prison, armoury, and keeper of the Crown Jewels.',
    latitude: 51.5085,
    longitude: -0.0761,
    timeline_start: 1078,
    timeline_end: 2025,
    location_label: 'City of London, by the River Thames',
    era_primary: 'Medieval',
    era_range: '1078 AD onward',
    types: ['Fortress', 'Prison', 'Royal Palace', 'World Heritage Site'],
    summaries: {
      gen: 'The Tower of London began as William the Conqueror’s great stone fortress on the Thames and grew into a royal palace, state prison, armoury, and treasury. For centuries it was the most feared address in England, the place where traitors were held and sometimes executed. Today, the Tower houses the Crown Jewels, resident ravens, and layers of stories from medieval kings to twentieth-century spies.',
    },
    echo: {
      title: 'The Ravens Who Keep the Kingdom',
      text: 'Legend says that if the ravens ever leave the Tower, the kingdom will fall. A Yeoman Warder, the Ravenmaster, is responsible for a small, decidedly spoiled flock. They have names, favourite snacks, and very strong opinions about tourists. The superstition may be modern, but it neatly captures how the Tower sits in Britain’s imagination: half history, half myth, all watchful.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Tower%20of%20London%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Tower_of_London',
      official_site: 'https://www.hrp.org.uk/tower-of-london/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'battle-of-hastings',
    name: 'The Battle of Hastings',
    siteType: 'battlefield',
    primaryEra: 'norman-conquest',
    country: 'england',
    region: 'east-sussex',
    teaser:
      'The 1066 clash near Hastings where William’s Norman forces toppled Harold Godwinson and remade the English crown.',
    latitude: 50.9072,
    longitude: 0.4858,
    timeline_start: 1066,
    timeline_end: 1066,
    location_label: 'Battle, near Hastings, East Sussex, England',
    era_primary: 'Norman Conquest',
    era_range: '1066',
    types: ['Battlefield', 'Historic Site'],
    summaries: {
      gen: 'The Battle of Hastings, fought on 14 October 1066, decided who would rule England. King Harold’s shield wall of Anglo-Saxon warriors held firm for much of the day until Norman cavalry and archers finally broke the line. Harold was killed and William of Normandy became “the Conqueror”, bringing a new French-speaking elite, castles, and a reshaped kingdom. The battlefield is centred on the town of Battle and the ruins of Battle Abbey.',
    },
    echo: {
      title: 'A Fallen King and a New Language',
      text: 'On the ridge at Senlac Hill, Harold’s personal standard fluttered above the shield wall. By nightfall it lay in the mud, and French became the language of power in England. For centuries after 1066, law, politics, and high society were conducted in French and Latin. A single day’s fighting helped shape the mix of languages that modern English still carries.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Battle%20Abbey%2C%20East%20Sussex%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Battle_of_Hastings',
      official_site:
        'https://www.english-heritage.org.uk/visit/places/1066-battle-of-hastings-abbey-and-battlefield/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'stratford-upon-avon',
    name: 'Stratford-upon-Avon',
    siteType: 'historic town',
    primaryEra: 'early-modern',
    country: 'england',
    region: 'warwickshire',
    teaser:
      'Medieval market town best known as Shakespeare’s birthplace, now a riverside hub for Tudor stories and theatre.',
    latitude: 52.1917,
    longitude: -1.7073,
    timeline_start: 1200,
    timeline_end: 2025,
    location_label: 'Market town on the River Avon, Warwickshire, England',
    era_primary: 'Early Modern to Modern',
    era_range: 'c. 1564–present',
    types: ['Historic Town', 'Shakespeare Location'],
    summaries: {
      gen: 'Stratford-upon-Avon is a medieval market town that became world-famous as the birthplace and burial place of William Shakespeare. Timber-framed houses, riverside walks, and parish churches still echo the town he knew. Today it is a major cultural centre, home to the Royal Shakespeare Company and a constant stream of visitors exploring his life, plays, and the wider history of Tudor and Stuart England.',
    },
    echo: {
      title: 'A Playwright Comes Home',
      text: 'Shakespeare left Stratford to build his career in London but returned as a wealthy man, buying New Place and investing in local land. When he died in 1616, he was buried in Holy Trinity Church beside the Avon. His epitaph warns would-be grave-disturbers to “curst be he that moves my bones” – a line good enough that nobody has yet risked testing it.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Stratford-upon-Avon%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Stratford-upon-Avon',
      official_site: 'https://visitstratforduponavon.co.uk/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'the-globe-theatre',
    name: 'The Globe Theatre',
    siteType: 'theatre',
    primaryEra: 'elizabethan-modern',
    country: 'england',
    region: 'london',
    teaser:
      'Shakespeare’s Bankside playhouse reborn in 1997, echoing the 1599 original with open-air performances and tours.',
    latitude: 51.5048,
    longitude: -0.0917,
    timeline_start: 1599,
    timeline_end: 2025,
    location_label: 'Bankside, Southwark, London',
    era_primary: 'Elizabethan and Modern',
    era_range: '1599–1644; reconstructed 1997–present',
    types: ['Theatre', 'Playhouse', 'Cultural Landmark'],
    summaries: {
      gen: 'The original Globe Theatre opened in 1599 on London’s Bankside, home to Shakespeare’s company, the Lord Chamberlain’s Men. It burned down in 1613, was rebuilt, and finally closed when theatres were shut in 1642. Today’s Shakespeare’s Globe, opened in 1997 a short distance from the original site, is a careful reconstruction using English oak and thatch, hosting performances, tours, and education programmes.',
    },
    echo: {
      title: 'Fire, Cannon, and a Very Unlucky Roof',
      text: 'In 1613, during a performance of Henry VIII, a small cannon fired for dramatic effect set the thatched roof of the Globe alight. The theatre burned to the ground, though one contemporary account says only a man’s breeches were singed – quickly doused with ale. Standing under the reconstructed thatch today, you are looking up at a roof rebuilt with that accident very much in mind.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Shakespeare%27s%20Globe%2C%20London%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Shakespeare%27s_Globe',
      official_site: 'https://www.shakespearesglobe.com/',
    },
    hero_image: '',
    echo_image: '',
  },
  {
    slug: 'hadrians-wall',
    name: 'Hadrian’s Wall',
    siteType: 'roman frontier',
    primaryEra: 'roman',
    country: 'england',
    region: 'northumberland-cumbria',
    teaser:
      'A 73-mile stone-and-turf frontier raised in AD 122 to anchor Rome’s north-west edge with forts, milecastles, and ditches.',
    latitude: 55.0212,
    longitude: -2.2888,
    timeline_start: 122,
    timeline_end: 410,
    location_label: 'Coast-to-coast across northern England',
    era_primary: 'Roman',
    era_range: 'c. AD 122–410',
    types: ['Roman Frontier', 'Defensive Wall', 'World Heritage Site'],
    summaries: {
      gen: 'Hadrian’s Wall is a Roman frontier line stretching about 73 miles (117 km) from the River Tyne to the Solway Firth. Built under Emperor Hadrian from AD 122, it combined stone walls, ditches, milecastles, turrets, and forts to control movement and trade at the empire’s north-western edge. Today, long stretches survive across dramatic landscapes, forming a UNESCO World Heritage Site and one of the most impressive Roman monuments in Britain.',
    },
    echo: {
      title: 'A Frontier of Many Languages',
      text: 'Soldiers along Hadrian’s Wall came from all over the empire: Spain, Syria, North Africa, Gaul, the Balkans. In the forts you would have heard Latin orders shouted over chatter in Celtic, Greek, Aramaic, and countless local dialects. What looks like a hard border on a map was, in reality, a zone of constant contact where cultures, religions, and accents collided and blended.',
    },
    map: {
      google_embed: 'https://www.google.com/maps?q=Hadrian%27s%20Wall%2C%20UK&output=embed',
    },
    links: {
      wikipedia: 'https://en.wikipedia.org/wiki/Hadrian%27s_Wall',
      official_site: 'https://www.english-heritage.org.uk/visit/places/hadrians-wall/',
    },
    hero_image: '',
    echo_image: '',
  },
]
